import { Navigate, Outlet, useNavigate, useSearchParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { selectIsAuth, setUser } from '../../slices/authSlice'
import { useEffect } from 'react'
import { useLazyGetUserByIdQuery } from '../../api/users'
import { useLazyGetSubscriptionQuery } from '../../api/stripe'

export const RequireAuth = ({ redirectTo = '/login' }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const isAuth = useSelector(selectIsAuth)
  const [getUser, user] = useLazyGetUserByIdQuery()
  const [getUserSubscription] = useLazyGetSubscriptionQuery()
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const initLocalStorage = async () => {
      try {
        const credentials = localStorage.getItem('credentials')
        const isAdmin = localStorage.getItem('isAdmin')

        if (!credentials) {
          dispatch(
            setUser({
              isAuth: false,
              isAdmin: false,
            })
          )
        } else {
          const { public_id } = JSON.parse(credentials)
          await getUser({ publicId: public_id }).unwrap()
        }
      } catch (e) {
        dispatch(
          setUser({
            isAuth: false,
          })
        )
        localStorage.removeItem('credentials')
      }
    }

    initLocalStorage()
  }, [])

  useEffect(() => {
    const initUser = async () => {
      try {
        if(user?.data?.public_id)
        {
        const userSubscription = await getUserSubscription({
          publicId: user?.data?.public_id,
        })

        const isActive = userSubscription?.data?.data?.some(
          (subscription) => subscription.plan.active
        )
        

        if (true/*user?.data?.confirmed*/) {
          dispatch(
            setUser({
              isAuth: true,
              isAdmin: user?.data?.admin,
              ...user?.data,
            })
          )

         
          if (user?.data?.has_onboard ||  localStorage.getItem('isSkipped')=='true') {
            navigate('./')
            return
            // window.location.replace(
            //   'https://demotraider.divergencecapital.com/#/get-started'
            // )
            // return
          }

          if (isActive) {
            navigate('./select-broker')
            return
          }

          navigate('./pricing')
        }
        else
        {
          navigate('./login');
        }
      }
      } catch (err) {

        console.log('error getting user', err.message)
        dispatch(
          setUser({
            isAuth: false,
          })
        )
      }
    }

    initUser()
  }, [user])

  if (isAuth === null) {
    return null
  }

  return isAuth ? <Outlet /> : <Navigate to={redirectTo} />
}
